import { withQueueTeams } from 'hocs';

import { QueuesTeams as QueuesTeamsImpl } from '../components/queuesTeams';

const QueuesTeamsWithHOC = withQueueTeams(QueuesTeamsImpl);

export { QueuesTeamsWithHOC as QueuesTeams };
